import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { usePet } from '../../modules'

import Receive from "../../components/reusable/receive"

const CountBadge = ({ count, tone }) => (
    <span className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold ${count > 0 ? tone : 'bg-gray-100 text-gray-500'}`}>
        {count}
    </span>
)

const Dashboard = ({ stores, setStore }) => {
    const history = useHistory()
    const [summary, setSummary] = useState(null)

    const [{ loading, error }] = usePet('inventoryAlertsSummary', {}, {
        notify: true,
        callback: ({ data }) => setSummary(data)
    })

    const goToStore = (row, path) => {
        const match = stores.find(st => String(st._id) === String(row?.store?._id))
        if (match) setStore(match)
        history.push(`/app/store/${path}`)
    }

    const rows = summary?.stores ?? []

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <div>
                        <h2 className="font-semibold text-gray-800">Dashboard</h2>
                        <p className="text-xs text-gray-500 italic">Inventory health across every store you have access to</p>
                    </div>
                </header>
                <div className="p-3">
                    <div className="overflow-x-auto">
                        <Receive error={error} loading={loading} progress>
                            {
                                rows.length > 0 ?
                                    <table className="table-auto w-full">
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2"><div className="font-semibold text-left">Store</div></th>
                                                <th className="p-2"><div className="font-semibold text-center">Low Stock</div></th>
                                                <th className="p-2"><div className="font-semibold text-center">Expiring Soon</div></th>
                                                <th className="p-2"><div className="font-semibold text-center">Expired</div></th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                rows.map(row => (
                                                    <tr key={row.store._id}>
                                                        <td className="p-2"><div>{row.store.name}</div></td>
                                                        <td className="p-2">
                                                            <div
                                                                className="text-center cursor-pointer"
                                                                onClick={() => goToStore(row, 'critical-items')}
                                                            >
                                                                <CountBadge count={row.lowStockCount} tone="bg-amber-100 text-amber-700" />
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div
                                                                className="text-center cursor-pointer"
                                                                onClick={() => goToStore(row, 'expiring-soon')}
                                                            >
                                                                <CountBadge count={row.nearExpiryCount} tone="bg-amber-100 text-amber-700" />
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div
                                                                className="text-center cursor-pointer"
                                                                onClick={() => goToStore(row, 'expiring-soon')}
                                                            >
                                                                <CountBadge count={row.expiredCount} tone="bg-red-100 text-red-700" />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="text-center my-8 text-gray-500">
                                        You don't have access to any stores yet.
                                    </div>
                            }
                        </Receive>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard
